import React from 'react';
import dynamic from 'next/dynamic';
import { Container, Typography, Box } from '@mui/material';
import { useStyles } from './styles';
import useIsMobile from 'hooks/useIsMobile';

const DynamicCircularCarousel = dynamic(() => import('components/CircularCarousel'));

const graphicalAbstracts = [
  {
    image: '/images/graphical-abstract-slide-1.jpg',
    description:
      'Como funciona a glândula pineal, o órgão enigmático que regula nosso sono. BBC News Brasil.',
    width: 366,
    height: 188,
    id: 1,
  },
  {
    image: '/images/graphical-abstract-slide-2.jpg',
    description:
      'Londono-Renteria, B., Cardenas, J. C., Troupin, A. & Colpitts, T. M. Natural Mosquito-Pathogen Hybrid IgG4 Antibodies in Vector-Borne Diseases: A Hypotesis. Frontiers in Immunology 7, 380 (2016)',
    width: 336,
    height: 192,
    id: 2,
  },
  {
    image: '/images/graphical-abstract-slide-3.jpg',
    description:
      'Cortabarria, A. S. de V. et al. In Utero Therapy for the Treatment of Sickle Cell Disease: Taking Advantage of the Fetal Immune System. From Cell Dev Biol 8, 624477 (2021).',
    width: 336,
    height: 245,
    id: 3,
  },
  {
    image: '/images/graphical-abstract-slide-4.jpg',
    description:
      "Scorza, F. A. et al. Sudden death in a rat model of Parkinson's disease. Clinics, 76, (2021)",
    width: 336,
    height: 309,
    id: 4,
  },
  {
    image: '/images/graphical-abstract-slide-5.jpg',
    description:
      'Rather, I. A., Lone, J. B., Bajpai, V. K. & Park, Y.-H. Zika Vírus Infection during Pregnancy and Congenital Abnormalities. Front Microbiol 8, 581 (2017).',
    width: 336,
    height: 225,
    id: 5,
  },
  {
    image: '/images/graphical-abstract-slide-6.jpg',
    description:
      'Babacic, H., Mehta, A., Merkel, O. & Schoser, B. CRISPR-cas gene-editing as plausible treatment of neuromuscular and nucleotide-repeat-expansio n diseases: A systematic review, PLos One 14, e0212198 (2019).',
    width: 336,
    height: 257,
    id: 6,
  },
];

export default function CarouselGraphicalAbstracts() {
  const classes = useStyles();
  const isMobile = useIsMobile();

  return (
    <Box className={classes.carouselSection}>
      <Container>
        <Typography className={classes.whiteColor} variant="h2" align="center">
          <b>
            Published Graphical Abstracts <br /> made with Mind the Graph
          </b>
        </Typography>

        <DynamicCircularCarousel
          classes={{
            root: classes.carouselRoot,
            carousel: classes.carousel,
            carouselItem: classes.carouselItem,
          }}
          autoplay={true}
          controlButtons={false}
          items={graphicalAbstracts.map((graphicalAbstract) => (
            <Box key={graphicalAbstract.id} className={classes.carouselContent}>
              <img
                src={graphicalAbstract.image}
                alt={graphicalAbstract.description}
                loading="lazy"
                width={graphicalAbstract.width}
                height={!isMobile ? graphicalAbstract.height : 300}
              />

              <Typography variant="body2">{graphicalAbstract.description}</Typography>
            </Box>
          ))}
        />
      </Container>
    </Box>
  );
}
